// Estas variables globales no se usan en el código proporcionado,
// pero las dejo por si las necesitas para otra cosa.
let direccionesPaginadas = [];
let paginaActual = 1;
const direccionesPorPagina = 6;

const shopId = document.getElementById('shop_id').value;
const customerId = document.getElementById('customer_id').value

document.addEventListener("DOMContentLoaded", function () {
  // --- SELECCIÓN DE ELEMENTOS ---
  const popupRedirect = document.getElementById("edit-address-redirect");
  const overlay = document.querySelector(".overlay");
  const btnRedirect = popupRedirect ? popupRedirect.querySelector(".btn-redirect") : null;
  //const btnCloseRedirect = popupRedirect ? popupRedirect.querySelector('.btn-close-redirect') : null;
  const popupMessageText = document.getElementById('popup-message-text');

  const editButtons = document.querySelectorAll('.btn-editar-tarjeta');
  const btnAbrirDesdeVacio = document.querySelector(".btn-edit");
  const btnAddDireccion = document.getElementById('btn-add-direccion');

  const deleteButtons = document.querySelectorAll('.btn-delete');
  const popupDefaultError = document.getElementById('default-address-error-popup');

  // Botones de cierre (ahora más genéricos)
  const closePopupButtons = document.querySelectorAll('.btn-close-popup');

  // === NUEVO: Función para abrir el popup de error ===
  function openDefaultErrorPopup() {
    if (popupDefaultError && overlay) {
      popupDefaultError.style.display = 'block';
      overlay.style.display = 'block';
    } else {
      console.error("Faltan elementos del popup de error para poder abrirlo.");
    }
  }

  // --- FUNCIÓN REUTILIZABLE PARA ABRIR EL POPUP DE REDIRECCIÓN ---
  function openRedirectPopup(message, buttonText, redirectUrl) {
    if (popupRedirect && popupMessageText && btnRedirect && overlay) {
      popupMessageText.textContent = message;
      btnRedirect.textContent = buttonText;
      btnRedirect.dataset.editUrl = redirectUrl;
      popupRedirect.style.display = 'block';
      overlay.style.display = 'block';
    } else {
      console.error("Faltan elementos del popup de redirección para poder abrirlo.");
    }
  }

  // --- FUNCIÓN GENÉRICA PARA CERRAR TODOS LOS POPUPS ---
  function closeAllPopups() {
    if (popupRedirect) popupRedirect.style.display = 'none';
    if (popupDefaultError) popupDefaultError.style.display = 'none'; // <-- Añadido
    if (overlay) overlay.style.display = 'none';
  }

  // --- LÓGICA DE EVENTOS ---

  // 1. Lógica para los botones "Editar" de cada tarjeta (MODIFICADO)
  editButtons.forEach(button => {
    button.addEventListener('click', function() {
      const addressId = this.dataset.addressId;
      const addressNumber = this.closest('.direccion-card-wrapper').querySelector('.card-header p strong').textContent.trim();

      if (addressId) {
        // Preparamos los tres datos para la función
        const message = `You are about to edit '${addressNumber}'. Click below to continue.`;
        const btnText = 'Edit Address'; // Texto para el botón
        const url = `https://shopify.com/${shopId}/account/profile`;
        
        // Llamamos a nuestra nueva función
        openRedirectPopup(message, btnText, url);
      }
    });
  });

  // 2. Lógica para los botones "Add a new address"
  function handleAddAddressClick() {
    const message = "You will be redirected to another page to add your shipping address.";
    const btnText = 'Add an Address';
    const url = `https://shopify.com/${shopId}/account/profile`;
    openRedirectPopup(message, btnText, url);
  }

  if (btnAbrirDesdeVacio) {
    btnAbrirDesdeVacio.addEventListener("click", handleAddAddressClick);
  }

  if (btnAddDireccion) {
    btnAddDireccion.addEventListener("click", handleAddAddressClick);
  }

  // === MODIFICADO: Lógica para los botones "Delete" ===
  deleteButtons.forEach(button => {
    button.addEventListener('click', async function() {
      // === NUEVA COMPROBACIÓN ===
      // Si el botón tiene el atributo 'data-is-default', muestra el popup de error y detiene la ejecución.
      if (this.dataset.isDefault === 'true') {
        openDefaultErrorPopup();
        return; // Detiene la función aquí
      }
      // ===========================

      const addressId = this.dataset.addressId;
      if (!addressId || !customerId) {
        console.error('Could not delete address: Missing customer or address ID.');
        return;
      }

      this.textContent = 'Deleting...';
      this.disabled = true;
      const originalButtonText = 'Delete';

      try {
        const response = await fetch('https://wtjcv2n52ymqasgisp4tfwcp6e0hkomc.lambda-url.us-east-2.on.aws/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            action: 'delete_direccion',
            customerId: customerId,
            addressId: addressId
          }),
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Failed to delete address.');
        }
          
        const cardToRemove = this.closest('.direccion-card-wrapper');
        if (cardToRemove) {
          cardToRemove.remove();
        }

        if (typeof inicializarPaginacion === "function") {
          inicializarPaginacion();
        }

        console.log('Address deleted successfully!');

      } catch (error) {
        console.error('Error deleting address:', error);
        
        this.textContent = originalButtonText;
        this.disabled = false;
      }
    });
  });

  // 3. Lógica para los botones de cierre y el overlay (ahora usa la función genérica)
  closePopupButtons.forEach(button => {
    button.addEventListener('click', closeAllPopups);
  });

  if (overlay) {
    overlay.addEventListener('click', closeAllPopups);
  }

  // 4. Lógica para el botón de redirección
  if (btnRedirect) {
    btnRedirect.addEventListener("click", function() {
      const redirectUrl = this.dataset.editUrl;
      if (redirectUrl) {
        window.location.href = redirectUrl;
      }
    });
  }

  // Al final, llamamos a la función de paginación si existe
  if (typeof inicializarPaginacion === "function") {
    inicializarPaginacion();
  }
});


// Tu función de paginación (sin cambios)
function inicializarPaginacion() {
  const container = document.getElementById('direction-cards-container');
  if (!container) return; // Buena práctica: salir si no hay contenedor

  const items = Array.from(container.querySelectorAll('.direccion-card-wrapper'));
  if (items.length === 0) return; // Salir si no hay direcciones

  const itemsPerPage = 6;
  const totalItems = items.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  let currentPage = 1;
  const paginationControlsContainer = document.getElementById('pagination-controls');
  if (!paginationControlsContainer) return; // Salir si no hay contenedor de paginación

  function showPage(page) {
    currentPage = page;
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
  
    items.forEach(item => item.style.display = 'none');
    items.slice(startIndex, endIndex).forEach(item => item.style.display = 'flex');
    updatePaginationControls();
  }
  
  function updatePaginationControls() {
    if (totalPages <= 1) {
      paginationControlsContainer.innerHTML = '';
      return;
    }
  
    paginationControlsContainer.innerHTML = '';
  
    const prevButton = document.createElement('button');
    prevButton.textContent = 'Anterior';
    prevButton.disabled = currentPage === 1;
    prevButton.addEventListener('click', () => showPage(currentPage - 1));
    paginationControlsContainer.appendChild(prevButton);
  
    for (let i = 1; i <= totalPages; i++) {
      const pageButton = document.createElement('button');
      pageButton.textContent = i;
      if (i === currentPage) {
        pageButton.classList.add('active');
        pageButton.disabled = true;
      }
      pageButton.addEventListener('click', () => showPage(i));
      paginationControlsContainer.appendChild(pageButton);
    }
  
    const nextButton = document.createElement('button');
    nextButton.textContent = 'Siguiente';
    nextButton.disabled = currentPage === totalPages;
    nextButton.addEventListener('click', () => showPage(currentPage + 1));
    paginationControlsContainer.appendChild(nextButton);
  }
  
  if (totalPages > 1) {
    showPage(1);
  } else {
    items.forEach(item => item.style.display = 'flex');
  }
}